module.exports = __webpack_public_path__ + "static/media/satImageExample.62dc8750.png";